import ImageFront1 from "./assets/men/2046033800_1_1_1_490x.progressive.jpg";
import ImageBack1 from "./assets/men/2046033800_2_1_1_490x.progressive.jpg";
import ImageFront2 from "./assets/women/8849335400_1_1_1_490x.progressive.jpg";
import ImageBack2 from "./assets/women/8849335400_2_1_1_490x.progressive.jpg";
import ImageFront3 from "./assets/women/2594443250_1_1_1_490x.progressive.jpg";
import ImageBack3 from "./assets/women/2594443250_2_1_1_490x.progressive.jpg";
import ImageFront4 from "./assets/watches/4913587800_1_1_1_490x.progressive.jpg";
import ImageBack4 from "./assets/watches/4913587800_2_2_1_490x.progressive.jpg";
import ImageFront5 from "./assets/women/1211407558_1_1_1_380x.progressive.jpg";
import ImageBack5 from "./assets/women/1211407558_2_1_1_380x.progressive.jpg";
import ImageFront6 from "./assets/men/2861922250_1_1_1_490x.progressive.jpg";
import ImageBack6 from "./assets/men/2861922250_2_1_1_490x.progressive.jpg";
import ImageFront7 from "./assets/footwears/4138332107_1_1_1_490x.progressive.jpg";
import ImageBack7 from "./assets/footwears/4138332107_2_1_1_490x.progressive.jpg";
import ImageFront8 from "./assets/men/1271613811_1_1_1_490x.progressive.jpg";
import ImageBack8 from "./assets/men/1271613811_2_1_1_490x.progressive.jpg";

const products = [
  {
    id: 1,
    brand: "Lacoste",
    name: "Simpson Sweatshirt",
    discount: "$450.00",
    price: "315.00",
    imageFront: `${ImageFront1}`,
    imageBack: `${ImageBack1}`,
    reviews: "12",
    perk_one: "New",
    perk_two: "-30%",
    save: "you save: $135.00 (30%)",
    color: "black",
    category: "men",
    count: 1,
  },
  {
    id: 2,
    brand: "Versace",
    name: "Short Denim Dungarees",
    price: "255.00",
    imageFront: `${ImageFront2}`,
    imageBack: `${ImageBack2}`,
    reviews: "15",
    color: "blue",
    category: "women",
    count: 1,
  },

  {
    id: 3,
    brand: "Prada",
    name: "Cotton Off-the-Shoulder Tee",
    price: "410.00",
    imageFront: `${ImageFront3}`,
    imageBack: `${ImageBack3}`,
    reviews: "10",
    color: "white",
    category: "women",
    count: 1,
  },
  {
    id: 4,
    brand: "Chanel",
    name: "Watch With Faux Leather Strap",
    price: "165.00",
    imageFront: `${ImageFront4}`,
    imageBack: `${ImageBack4}`,
    reviews: "12",
    color: "black",
    category: "watches",
    count: 1,
  },
  {
    id: 5,
    brand: "Lacoste",
    name: "Faux Shearling Cotton Jacket",
    price: "270.00",
    imageFront: `${ImageFront5}`,
    imageBack: `${ImageBack5}`,
    reviews: "15",
    color: "blue",
    category: "women",
    count: 1,
  },
  {
    id: 6,
    brand: "Dolce & Gabana",
    name: "Two-Tone Sleeveless Shirt",
    price: "295.00",
    imageFront: `${ImageFront6}`,
    imageBack: `${ImageBack6}`,
    reviews: "14",
    color: "white",
    category: "men",
    count: 1,
  },
  {
    id: 7,
    brand: "Zara",
    name: "Men Camouflage Mesh Sneakers",
    price: "390.00",
    imageFront: `${ImageFront7}`,
    imageBack: `${ImageBack7}`,
    reviews: "19",
    color: "brown",
    category: "sneakers",
    count: 1,
  },
  {
    id: 8,
    brand: "Calvin Kelvin",
    name: "Tailored Fit Men Polo Shirt",
    price: "310.00",
    imageFront: `${ImageFront8}`,
    imageBack: `${ImageBack8}`,
    reviews: "15",
    color: "gray",
    category: "men",
    count: 1,
  },
];

export default products;
